import { v4 } from "uuid";
import { ExcelMapperColSetting } from "./excel-mapper-col-setting";

export class ExcelMapperCol {
	uid:string = v4();
	NewHeaderName:string = "";
	NewValue:ExcelMapperColSetting = new ExcelMapperColSetting();

	public constructor(data?:any){
		if (!data) return;
		this.NewHeaderName = data.NewHeaderName || "";
		this.NewValue = new ExcelMapperColSetting(data.NewValue);
	}

	public getJSON(){
		return {
			NewHeaderName: this.NewHeaderName,
			NewValue: this.NewValue.getJSON()
		};
	}

	public toString():string{
		return this.NewHeaderName.toString() + "/" + this.NewValue.toString();
	}

}